/**
 * Product Image Zoom & Lightbox
 * - CSS transform-based hover zoom (works on any image aspect ratio)
 * - Magnific Popup lightbox on click (desktop & mobile)
 */

$(document).ready(function () {

  /* ============================================================
   * 1. Thumbnail sub-image click → update main image
   * ============================================================ */
  $(document).on('click', '.sub-image', function (e) {
    e.preventDefault();

    var $thumb   = $(this);
    var bigSrc   = $thumb.attr('href');
    var smallSrc = $thumb.data('small') || $thumb.attr('href');
    var pos      = $thumb.data('pos') || 1;

    // Mark active thumb
    $('.sub-image').closest('.item').removeClass('current');
    $thumb.closest('.item').addClass('current');

    // Update the main image src and lightbox href
    var $mainLink = $('.product-zoom-image .main-image');
    var $mainImg  = $mainLink.find('img#productPhotoImg, img');

    $mainImg.attr('src', smallSrc);
    $mainLink.attr('href', bigSrc);
    $mainLink.attr('data-mfp-src', bigSrc);

    // Store current position for lightbox
    $('#light-box-position').val(pos);

    return false;
  });

  /* ============================================================
    * 2. Cursor-tracking pan zoom on main image
   *    — mousemove updates transform-origin instantly (no transition)
   *      so the zoomed image follows the cursor for detail inspection.
   *    — mouseleave resets origin to center so zoom-out looks natural.
   * ============================================================ */
  $(document).on('mouseenter', '.product-zoom-image .main-image', function () {
    // Disable transition on transform-origin so panning is instant
    $(this).find('img').css('transition',
      'transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.3s ease'
    );
  });
  $(document).on('mousemove', '.product-zoom-image .main-image', function (e) {
    var $link  = $(this);
    var $img   = $link.find('img');
    var offset = $link.offset();
    var relX   = e.pageX - offset.left;
    var relY   = e.pageY - offset.top;
    var w      = $link.outerWidth();
    var h      = $link.outerHeight();
    // Clamp to [0, 100]%
    var xPct = Math.max(0, Math.min(100, (relX / w) * 100));
    var yPct = Math.max(0, Math.min(100, (relY / h) * 100));
    // Update origin instantly (no transition on transform-origin)
    $img[0].style.transitionProperty = 'opacity';  // only opacity transitions during pan
    $img[0].style.transformOrigin    = xPct + '% ' + yPct + '%';
  });
  $(document).on('mouseleave', '.product-zoom-image .main-image', function () {
    var $img = $(this).find('img');
    // Re-enable full transition for the zoom-out animation
    $img.css({
      'transition'       : 'transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 0.3s ease',
      'transform-origin' : 'center center'
    });
  });
  function buildGalleryItems() {
    var items = [];
    // Collect all product images from thumbnails
    $('.sub-image').each(function () {
      var src = $(this).attr('href');
      if (src) {
        items.push({ src: src, type: 'image' });
      }
    });
    // Sticky layout: multiple .main-image links (no thumbs on desktop)
    if (items.length === 0) {
      $('.product-zoom-image .main-image').each(function () {
        var src = $(this).attr('href');
        if (src) {
          items.push({ src: src, type: 'image' });
        }
      });
    }
    // Last fallback: grab any main image href
    if (items.length === 0) {
      var mainSrc = $('.product-zoom-image .main-image').first().attr('href');
      if (mainSrc) items.push({ src: mainSrc, type: 'image' });
    }
    return items;
  }

  // Open lightbox from main image click (works for both standard and sticky layout)
  $(document).on('click', '.product-zoom-image .main-image', function (e) {
    e.preventDefault();

    var items    = buildGalleryItems();
    var $clicked = $(this);
    var startPos = 0;

    // Sticky layout: each .main-image has data-pos
    if ($clicked.data('pos')) {
      startPos = parseInt($clicked.data('pos'), 10) - 1;
    } else {
      // Standard layout: use stored light-box-position
      startPos = parseInt($('#light-box-position').val() || 1, 10) - 1;
    }
    if (startPos < 0) startPos = 0;
    if (startPos >= items.length) startPos = items.length - 1;

    $.magnificPopup.open({
      items      : items,
      type       : 'image',
      gallery    : { enabled: true },
      image      : { titleSrc: '' },
      index      : startPos,
      callbacks  : {
        beforeOpen: function () {
          this.st.image.markup = this.st.image.markup.replace(
            'mfp-figure',
            'mfp-figure mfp-product-lightbox'
          );
        }
      }
    });
  });

  // Also allow clicking thumb images to open lightbox directly on mobile
  $(document).on('click', '.sub-image .lightbox-trigger', function (e) {
    e.stopPropagation();
    e.preventDefault();
    var idx   = $(this).closest('.sub-image').data('pos') - 1 || 0;
    var items = buildGalleryItems();
    $.magnificPopup.open({ items: items, type: 'image', gallery: { enabled: true }, index: idx });
  });

  /* ============================================================
   * 3. Owl Carousel for .additional-images thumbnails
   * ============================================================ */
  oczoom.initAdditionalImagesOwl();
  $('.sub-image:first').closest('.item').addClass('current');
});


/* ============================================================
 * oczoom namespace (kept for back-compat; lightbox now uses Magnific)
 * ============================================================ */
var oczoom = {
  'initAdditionalImagesOwl': function () {
    $('.additional-images').owlCarousel({
      loop      : false,
      margin    : 8,
      nav       : true,
      dots      : false,
      navText   : ['<i class="icon-chevron-left"></i>', '<i class="icon-chevron-right"></i>'],
      responsive: {
        0   : { items: 3 },
        480 : { items: 4 },
        768 : { items: 5 },
        992 : { items: 3 },
        1200: { items: 4 }
      }
    });
  }
};